
import BaseModel from './BaseModel';
export default class PackageRate extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.hotelId = data.hotelId || undefined;
        this.name = this.translate.name || data.name || undefined;
        this.description = this.translate.description || data.description || undefined;
        this.order = data.order || 0;
        this.code = data.code || undefined;
        this.isActive = data.isActived;
        this.isCanEdit = data.isCanEdit;
        this.isCanDelete = data.isCanDelete;
        this.bookingDatesConfig = new BookingDatesConfig(data.bookingDatesConfig || {});
        this.stayingDatesConfig = new StayingDatesConfig(data.stayingDatesConfig || {});
        this.channel = data.channel?.length ? data.channel : [""];
        this.isIncludeConditions = data.isIncludeConditions || false;
        this.issueType = data.issueType || "";
        this.maxRoomNight = data.maxRoomNight || undefined;
        this.maxRoomNumber = data.maxRoomNumber || undefined;
        this.minRoomNight = data.minRoomNight || undefined;
        this.minRoomNumber = data.minRoomNumber || undefined;
        this.objectApplyType = data.objectApplyType || undefined;
        this.objectApplyValue = data.objectApplyValue?.length ? data.objectApplyValue : [""];
        this.reasons = data.reasons || "";
        this.extraInfos = this.translate.extraInfos || this.initExtraInfos();
        this.displaySale = data.displaySale || [];
        this.hotel = data.hotel || "";
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            hotelId: this.hotelId,
            name: this.name,
            description: this.description,
            order: this.order || 0,
            code: this.code,
            isActive: this.isActive,
            bookingDatesConfig: this.bookingDatesConfig,
            stayingDatesConfig: this.stayingDatesConfig,
            channel: this.channel.filter(x=>x === "").length === this.channel.length ? [] : this.channel,
            isIncludeConditions: this.isIncludeConditions,
            issueType: this.issueType,
            maxRoomNight: this.maxRoomNight,
            maxRoomNumber: this.maxRoomNumber,
            minRoomNight: this.minRoomNight,
            minRoomNumber: this.minRoomNumber,
            objectApplyType: this.objectApplyType,
            objectApplyValue: this.objectApplyValue.filter(x=>x === "").length === this.objectApplyValue.length ? [] : this.objectApplyValue,
            displaySale: this.displaySale,
        });

        if (hasTranslate) result.translate = () => {
            return {
                packageRateId: this.id,
                title: this.titleDesc,
                languageCode: this.languageCode,
                extraInfos: this.extraInfos,
            }
        }

        return result;
    }

    initExtraInfos() {
        return [
            { title: 'Mô tả', content: '' },
            { title: 'Bao gồm', content: '' },
            { title: 'Điều khoản', content: '' },
            { title: 'Chính sách hoàn hủy', content: '' }
        ]
    }
}

class BookingDatesConfig {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.id = data.id || undefined;
        this.daysOfWeek = data.daysOfWeek || [];
        this.hoursFrom = data.hoursFrom || "";
        this.hoursTo = data.hoursTo || "";
        this.isConfgAdvanced = data.isConfgAdvanced || false;
        this.packageRateId = data.packageRateId;
        this.dateRanges = (data.dateRanges?.length ? data.dateRanges : [{}]).map(item => new DateRanges(item));
    }
}

class StayingDatesConfig {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.id = data.id || undefined;
        this.daysOfWeek = data.daysOfWeek || [];
        this.isConfgAdvanced = data.isConfgAdvanced || false;
        this.packageRateId = data.packageRateId;
        this.dateRanges = (data.dateRanges?.length ? data.dateRanges : [{}]).map(item => new DateRanges(item));
    }
}

class DateRanges {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.order = data.order || 0;
        this.dateRange = new DateRange(data.dateRange || {});
    }
}

class DateRange {
    constructor(data = {}) {
        this.setData(data);
    }

    setData(data) {
        this.dateFrom = data.dateFrom || null;
        this.dateTo = data.dateTo || null;
    }
}